import React from 'react';
import { Tooltip, Typography, theme } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined, MinusOutlined } from '@ant-design/icons';
import styles from '../../pages/Statistics/statistics.module.css';

const { Text } = Typography;

interface AppStatsCardProps {
  title: string;
  value: number | string;
  icon?: React.ReactNode;
  className?: string;
  prefix?: string;
  suffix?: string;
  compact?: boolean;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  tooltip?: string;
}

export const AppStatsCard: React.FC<AppStatsCardProps> = ({
  title,
  value,
  icon,
  className = '',
  prefix,
  suffix,
  compact = false,
  trend,
  tooltip,
}) => {
  const { token } = theme.useToken();

  const trendColor = () => {
    if (!trend || trend.value === 0) return token.colorTextTertiary;
    return trend.isPositive ? token.colorSuccess : token.colorError;
  };

  const trendIcon = () => {
    if (!trend || trend.value === 0) return <MinusOutlined />;
    return trend.isPositive ? <ArrowUpOutlined /> : <ArrowDownOutlined />;
  };

  const cardClassName = [styles.metricCard, compact ? styles.metricCardCompact : '', className]
    .filter(Boolean)
    .join(' ');

  const content = (
    <div className={cardClassName}>
      {icon && <div className={styles.metricIcon}>{icon}</div>}
      <div className={styles.metricValue}>
        {prefix && <span className={styles.metricAffix}>{prefix}</span>}
        {typeof value === 'number' ? value.toLocaleString('ru-RU') : value}
        {suffix && <span className={styles.metricAffix}>{suffix}</span>}
      </div>
      <div className={styles.metricLabel}>{title}</div>
      {trend && (
        <div className={styles.metricTrend} style={{ color: trendColor() }}>
          {trendIcon()}
          <span>{Math.abs(trend.value)}%</span>
          <Text type="secondary" style={{ fontSize: 11 }}>
            за период
          </Text>
        </div>
      )}
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="top">
        {content}
      </Tooltip>
    );
  }

  return content;
};